import { render, staticRenderFns } from "./legendTemperature.vue?vue&type=template&id=1812a3e2&scoped=true"
import script from "./legendTemperature.vue?vue&type=script&lang=ts"
export * from "./legendTemperature.vue?vue&type=script&lang=ts"
import style0 from "./legendTemperature.vue?vue&type=style&index=0&id=1812a3e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1812a3e2",
  null
  
)

export default component.exports